import sortBy from 'lodash/sortBy';

const initialState = {
  amazonBalances: null,
  rankedAccounts: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_DYNAMIC_DATA': {
      return {
        ...state,
        amazonAccounts: sortBy(payload.data.amazonAccounts, item => {
          return (item.external ? 'a_' : 'b_') + (item.label || '').toLowerCase();
        }),
      };
    }
    case 'SET_AMAZON_BALANCES': {
      const { amazonBalances, rankedAccounts } = payload;
      return {
        ...state,
        amazonBalances,
        rankedAccounts,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/WorkArea.reducer.js